import { i18n } from '@lingui/core'
import { t } from '@lingui/core/macro'

/**
 * How a review-surface timestamp reads back: recent decisions as an age
 * ("3h ago"), anything older than a fortnight as a plain date. An unparseable
 * value is shown verbatim rather than swallowed.
 */
export const fmtWhen = (ts: string | null | undefined): string => {
  if (!ts) return ''
  const d = new Date(ts)
  if (Number.isNaN(d.getTime())) return ts
  const mins = Math.round((Date.now() - d.getTime()) / 60000)
  if (mins < 1) return t`just now`
  if (mins < 60) return t`${mins}m ago`
  if (mins < 60 * 24) {
    const hours = Math.round(mins / 60)
    return t`${hours}h ago`
  }
  if (mins < 60 * 24 * 14) {
    const days = Math.round(mins / (60 * 24))
    return t`${days}d ago`
  }
  return d.toLocaleDateString(i18n.locale)
}
